/*
 * @Author: your name
 * @Date: 2020-09-06 20:50:44
 * @LastEditTime: 2022-11-08 16:40:25
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/plugins/theme.js
 */
// It cannot be removed. Some operations are required to prevent shaking. It is the first time to enter
// 不能去掉。防抖一些操作，防抖第一次进入。
document.body.style.setProperty('--menu-primary-background-colour', '#14C4BC')
document.body.style.setProperty('--menu-header-background-colour', '#14C4BC')
document.body.style.setProperty('--menu-header-colour', '#fff')
document.body.style.setProperty('--menu-primary-text-colour', '#000')
